import { connect } from 'react-redux';
import NoteContext from './NoteContent';
import { updateNote, deleteNote } from '../../../../../../redux';

export default connect(null, { editNote: updateNote, deleteNote })(NoteContext);
